import React, { useEffect, useState, useContext, useRef, useMemo } from 'react'
import { ReactInternetSpeedMeter } from 'react-internet-meter'

import "./dashboard.css"
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from "@material-ui/styles";
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { UserContext } from './UserContext';
import { color } from '@mui/system';
import { Button } from '@mui/material';
import FileUploadIcon from "@mui/icons-material/FileUpload";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { TextField, Container, Autocomplete } from '@mui/material';
import OnlinePredictionSharpIcon from '@mui/icons-material/OnlinePredictionSharp';
import BackupIcon from '@mui/icons-material/Backup';
import Timer from './Timer';
import ScheduleInterview from './ScheduleInterview';
import ScheduleInterviewUI from './ScheduleInterviewUI';
import SearchIcon from '@mui/icons-material/Search';
import ApplicantPopup from './ApplicantPopup';
import { width } from '@material-ui/system';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import StopCircleIcon from "@mui/icons-material/StopCircle";
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Peer from 'simple-peer';
import { parse, set } from 'date-fns';
import { clear } from '@testing-library/user-event/dist/clear';
import { io } from 'socket.io-client';
import CallIcon from '@mui/icons-material/Call';
import EmployeeDashboardMob from './EmployeeDashboardMob';
import EmployeeDashboardPC from './EmployeeDashboardPC';
import EmployeeChats from './EmployeeChats';
import AdminDashboardMob from './MobUI/AdminDashboardMob';
import apiFetch from '../utils/apiFetch';
import MonitorStaff from './MonitorStaff';
import AssessmentIcon from '@mui/icons-material/Assessment';
import TimeUtilizationReport from './TimeUtilizationReport';
import { useCallSocket } from '../hooks/useCallSocket';

const stopModalStyle = {
  position: 'relative',
  margin: "auto",
  height: "auto",
  minWidth: 325,
  maxWidth: 385,
  scrollY: "auto",
  bgcolor: 'background.paper',
  border: '2px solid #000',
};

const opentimer = {
  position: 'relative',
  margin: "auto",
  height: "auto",
  minWidth: 375,
  maxWidth: 500,
  scrollY: "auto",
  bgcolor: 'background.paper',
  border: '2px solid #000',
};

const Login = {
  position: 'relative',
  margin: "auto",
  height: "1000px",
  width: "800px",
  scrollY: "auto",
  bgcolor: 'background.paper',
  border: '2px solid #000',
};

const useStyles = makeStyles((theme) => ({
  video: {
    width: "350px",
    "@media (max-width: 1440px)": {
      mobileMenuStyle: {
        width: "250px",
      },
    },
  },
  gridContainer: {
    justifyContent: "center",
    "@media (max-width: 1440px)": {
      mobileMenuStyle: {
        flexDirection: "column",
      },
    },
  },
  paper: {
    padding: "10px",
    border: "2px solid black",
    margin: "0px",
  },
}));

const Dashboard = (props) => {
  const classes = useStyles();

  // ===================== 1. STATE & HOOKS (TOP) =====================
  const { user, setUser } = useContext(UserContext);
  const effectiveUser = user;

  // Role Logic: Staff (5) = Broadcaster. Everyone else = Viewer.
  const isBroadcaster = false;

  const {
    callUser, stopCall, remoteStream, callState, networkStats,
    sendToggleVideo, startRecording, stopRecording, recording,
    networkQuality, activeUsers: liveUsers
  } = useCallSocket({
    user: effectiveUser,
    isBroadcaster: isBroadcaster,
    onIncomingCall: null
  });

  const [users, setUsers] = useState([]);
  const [activeUsers, setActiveUsers] = useState([]);
  const [status, setStatus] = useState();
  const [rowData, setRowData] = useState([]);
  const [progress, setProgress] = React.useState(0);
  const [fromDate, setFromDate] = useState(new Date().toISOString().substring(0, 10));
  const [toDate, setToDate] = useState(new Date().toISOString().substring(0, 10));
  const [loadTime, setLoadTime] = useState(new Date());
  const [showOnlyHR, setShowOnlyHR] = useState(true);
  const [selectedRow, setSelectedRow] = useState();
  const [searchData, setSearchData] = useState("");
  const [openShedule, setOpenScedule] = React.useState(false);
  const [openApplicant, setOpenApplicant] = useState(false);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState("mobile");
  const isCallingActive = useRef(false);
  const [stopComments, setStopComments] = useState("");
  const [openStopModel, setOpenStopModel] = useState(false);
  const [userStatusId, setUserStatusId] = useState("");
  const [result, setResult] = useState([]);
  const [openLoginHours, setLoginHours] = React.useState(false);
  const [loginDetails, setLoginDetails] = useState([]);
  const isLoading = useRef(true);
  const alertStart = useRef(new Date());
  const [empName, setEmpName] = useState("")
  const [empCallingTime, setCallingTime] = useState("")
  const [staffId, setStaffId] = useState(null);
  const [currentMessage, setCurrentMessage] = useState("")
  const [callFilterText, setCallFilterText] = useState("Graduate");
  const [filterCallsByEducation, setFilterCallsByEducation] = useState(false);
  const [showHRDasboard, setShowHRDasboard] = useState(false);
  const [messageList, setMessageList] = useState([]);
  const [wifiSpeed, setWifiSpeed] = useState(0)
  const [reportOpen, setReportOpen] = useState(false);
  const [reportUserId, setReportUserId] = useState(null);
  const [reportUserName, setReportUserName] = useState("");

  const longCallMsg = "I am on Call from long time!!";
  const longTimeIdleMsg = "I am idle since long time!";

  const [socketID, setSocketID] = useState("");
  const roomIdRef = useRef("");
  const audio = useRef();
  const [gridVersion, setGridVersion] = useState(0);

  // --- DRAGGABLE LOGIC ---
  const [dragPos, setDragPos] = useState({ x: window.innerWidth - 380, y: window.innerHeight - 300 });
  const [isDragging, setIsDragging] = useState(false);
  const dragOffset = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const handleDragMove = (e) => {
      if (!isDragging) return;
      setDragPos({ x: e.clientX - dragOffset.current.x, y: e.clientY - dragOffset.current.y });
    };
    const handleDragEnd = () => setIsDragging(false);
    if (isDragging) {
      window.addEventListener('mousemove', handleDragMove);
      window.addEventListener('mouseup', handleDragEnd);
    }
    return () => {
      window.removeEventListener('mousemove', handleDragMove);
      window.removeEventListener('mouseup', handleDragEnd);
    };
  }, [isDragging]);

  // Sync Active Users
  useEffect(() => {
    if (liveUsers) {
      setActiveUsers(liveUsers);
    }
  }, [liveUsers]);

  // =========================================================
  // ✅ 2. HELPER FUNCTIONS & API CALLS
  // =========================================================

  const getLoginDetails = (id) => {
    let apiURL = process.env.REACT_APP_API_URL + "/usercallingstatus/logindetails/" + id;
    let apiParams = {
      method: "GET",
      headers: {
        authtoken: localStorage.getItem("loggedintoken")
      }
    };
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          setLoginDetails(repos.data);
        } else props.showAlert("" + (repos.message || repos), "success");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  const OpenLoginhoursGrid = (id, name, time) => {
    setEmpName(name)
    setCallingTime(time)
    setLoginHours(true)
    getLoginDetails(id)
  }

  const viewData = (row) => {
    window.isIntentionalRedirect = true;
    window.location.href = "/interviewdetails?selectedCell=" + row;
  }

  const UpdateMessagedStatus = (intwID) => {
    let apiURL = process.env.REACT_APP_API_URL + "/interview/messagedStatus/" + intwID;
    let apiParams = {
      method: "POST",
      headers: {
        updatedbyid: user._id,
        updatedbyname: user.name,
        authtoken: localStorage.getItem("loggedintoken")
      }
    };
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
        } else props.showAlert("" + (repos.message || repos), "success");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  const getUsers = () => {
    let apiURL = process.env.REACT_APP_API_URL + "/users/getusers"
    let apiParams = {
      method: "GET",
      headers: { authtoken: localStorage.getItem("loggedintoken") }
    };
    console.log("ENV:", process.env.REACT_APP_API_URL);
    console.log("API URL:", apiURL);
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          setUsers(repos.data)
        } else props.showAlert("" + (repos.message || repos), "success");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  const interviewStatus = () => {
    let apiURL = process.env.REACT_APP_API_URL + "/interview/status";
    let apiParams = {
      method: "GET",
      headers: { authtoken: localStorage.getItem("loggedintoken") },
    };
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          let percentage = (repos.data / 50) * 100
          setStatus(percentage)
        } else props.showAlert("" + (repos.message || repos), "success");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  function max_of_three(x, y, z, a, b, c, d, e) {
    let max_val;
    if (x.length > y.length) { max_val = x; } else { max_val = y; }
    if (z.length > max_val.length) { max_val = z; }
    if (a.length > max_val.length) { max_val = a; }
    if (b.length > max_val.length) { max_val = b; }
    if (c.length > max_val.length) { max_val = c; }
    if (d.length > max_val.length) { max_val = d; }
    if (e.length > max_val.length) { max_val = e; }
    return max_val;
  }

  const LoadPreviousData = () => {
    let apiParams;
    apiParams = {
      method: "GET",
      headers: {
        fromdate: fromDate,
        todate: toDate,
        authtoken: localStorage.getItem("loggedintoken")
      }
    };
    let apiURL = process.env.REACT_APP_API_URL + "/dashboard/searchbydate/" + (user?.accesstype === "1" ? user._id : "")
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          var passed = repos.data.passed;
          var failed = repos.data.failed;
          var scheduled = repos.data.scheduled;
          var messaged = repos.data.messaged;
          var notReachable = repos.data.notReachable;
          var pending = repos.data.pending;
          var applied = repos.data.applied;
          var verified = repos.data.verified;
          var verificationFailed = repos.data.verificationFailed;
          var verificationPending = repos.data.verificationPending;
          var verificationAvailable = repos.data.verificationAvailable;
          var currentCandidate = repos.data.currentCandidate;
          var idleTimeRec = repos.data.idleTime;
          let namesCol = max_of_three(passed, failed, scheduled, pending, verified, verificationFailed, verificationPending, currentCandidate, idleTimeRec)

          setRowData(namesCol.map((name, id) => {
            let idleTime = Math.abs(new Date().getTime() - new Date((idleTimeRec.filter(rec => rec._id === name)[0] || { closedOn: new Date().toISOString() }).closedOn).getTime()) / 1000;
            let openTime = (Math.abs(new Date().getTime() - new Date((currentCandidate.filter(rec => rec.createdbyname === name)[0] || { openedOn: new Date().toISOString() }).openedOn).getTime()) / 1000) + parseInt((currentCandidate.filter(rec => rec.createdbyname === name)[0] || { timeSpent: 0 }).timeSpent);
            openTime = parseInt(openTime) > 0 ? parseInt(openTime) : parseInt(idleTime);
            return {
              id,
              name: name,
              verified: (verified.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              verificationFailed: (verificationFailed.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              verificationPending: (verificationAvailable.filter(rec => rec._id === name)[0] || { count: 0 }).count + "/" + (verificationPending.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              passed: (passed.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              messaged: (messaged.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              notReachable: (notReachable.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              failed: (failed.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              scheduled: (scheduled.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              called: (passed.filter(rec => rec._id === name)[0] || { count: 0 }).count + (failed.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              pending: (applied.filter(rec => rec._id === name)[0] || { count: 0 }).count + "/" + (pending.filter(rec => rec._id === name)[0] || { count: 0 }).count,
              currentCandidate: (currentCandidate.filter(rec => rec.createdbyname === name)[0] || { _id: "" }).name,
              interviewid: (currentCandidate.filter(rec => rec.createdbyname === name)[0] || { _id: "" })._id,
              openTime: openTime,
            }
          }))
          setLoadTime(new Date())
        } else props.showAlert(repos.message || repos, "success");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  const LoadCurrentData = () => {
    isLoading.current = true;
    if (fromDate === new Date().toISOString().substring(0, 10) && toDate === new Date().toISOString().substring(0, 10)) {
      let apiParams = {
        method: "GET",
        headers: {
          fromdate: fromDate,
          todate: toDate,
          authtoken: localStorage.getItem("loggedintoken")
        }
      };
      let apiURL = process.env.REACT_APP_API_URL + "/dashboard/searchbydate/" + (user?.accesstype === "1" ? user._id : "")
      apiFetch(apiURL, apiParams)
        .then((res) => (res.status === 200 ? res.json() : res.text()))
        .then(async (repos) => {
          if (repos.data) {
            setResult(repos.data.userStatus)
            var passed = repos.data.passed;
            var messaged = repos.data.messaged;
            var notReachable = repos.data.notReachable;
            var failed = repos.data.failed;
            var scheduled = repos.data.scheduled;
            var pending = repos.data.pending;
            var applied = repos.data.applied;
            var verificationAvailable = repos.data.verificationAvailable;
            var verified = repos.data.verified;
            var verificationFailed = repos.data.verificationFailed;
            var verificationPending = repos.data.verificationPending;
            var currentCandidate = repos.data.currentCandidate;
            var userStatus = repos.data.userStatus;
            var loggedTime = repos.data.loggedinTime;
            var calledTime = repos.data.callingTime;
            var idleTimeRec = repos.data.idleTime;
            var longCalls = repos.data.longCalls;
            let namesCol = repos.data.users;

            let newData = namesCol.map((name, id) => {
              let idleTime = Math.abs(new Date(new Date().toISOString()).getTime() - new Date((idleTimeRec.filter(rec => rec._id === name)[0] || { closedOn: new Date().toISOString() }).closedOn).getTime()) / 1000;
              idleTime = parseInt(idleTime);
              let openTime = (Math.abs(new Date(new Date().toISOString()).getTime() - new Date((currentCandidate.filter(rec => rec.createdbyname === name)[0] || { openedOn: new Date().toISOString() }).openedOn).getTime()) / 1000) + parseInt(((currentCandidate.filter(rec => rec.createdbyname === name)[0] || { timeSpent: 0 }).timeSpent));
              openTime = parseInt(openTime) > 0 ? parseInt(openTime) : parseInt(idleTime)
              let logTimeValue = (loggedTime.filter(rec => rec._id.name === name)[0] || { name: "" }).TotalTime;

              const cleanName = (n) => n ? n.toString().toLowerCase().trim() : "";
              const currentRowName = cleanName(name);

              let agentUser = users.find(u => cleanName(u.name) === currentRowName);
              let agentId = agentUser ? agentUser._id : "";

              let newLogTimeValue = parseInt(logTimeValue * 0.65);
              let calTimeValue = (calledTime.filter(rec => rec._id.name === name)[0] || { name: "" }).TotalTime;
              calTimeValue = parseInt(calTimeValue)
              let callVol = ((passed.filter(rec => rec._id === name)[0] || { count: 0 }).count + (failed.filter(rec => rec._id === name)[0] || { count: 0 }).count);
              let newCalVol = parseInt(callVol * 0.15)
              let longCallVol = (longCalls || [].filter(rec => rec.name === name)[0] || { name: "" }).count;
              longCallVol = parseInt(longCallVol)
              let time = (loggedTime.filter(rec => rec._id.name === name)[0] || { name: "" }).TotalTime;
              let num = (Math.round(time) * 100) / 100;
              let hours = (num / 60);
              let rhours = Math.floor(num / 60);
              let minutes = (hours - rhours) * 60;
              let rminutes = Math.round(minutes);
              let cTime = (calledTime.filter(rec => rec._id.name === name)[0] || { name: "" }).TotalTime;
              let cNum = (Math.round(cTime) * 100) / 100;
              let cHours = (cNum / 60);
              let cRhours = Math.floor(cNum / 60);
              let cMinutes = (cHours - cRhours) * 60;
              let cRminutes = Math.round(cMinutes);
              let iTime = parseInt(time) - parseInt(cTime);
              let iNum = (Math.round(iTime) * 100) / 100;
              let iHours = (iNum / 60);
              let iRhours = Math.floor(iHours / 60);
              let iMinutes = (iHours - iRhours) * 60;
              let iRminutes = Math.round(iMinutes);
              let loginid = (loggedTime.filter((req) => req._id.name === name)).map(r => r._id.id)[0];

              return {
                id,
                name: name,
                verified: (verified.filter(rec => rec._id === name)[0] || { count: 0 }).count,
                verificationFailed: (verificationFailed.filter(rec => rec._id === name)[0] || { count: 0 }).count,
                verificationPending: (verificationAvailable.filter(rec => rec._id === name)[0] || { count: 0 }).count + "/" + (verificationPending.filter(rec => rec._id === name)[0] || { count: 0 }).count,
                passed: (passed.filter(rec => rec._id === name)[0] || { count: 0 }).count,
                messaged: (messaged.filter(rec => rec._id === name)[0] || { count: 0 }).count,
                notReachable: (notReachable.filter(rec => rec._id === name)[0] || { count: 0 }).count,
                failed: (failed.filter(rec => rec._id === name)[0] || { count: 0 }).count,
                scheduled: (scheduled.filter(rec => rec._id === name)[0] || { count: 0 }).count,
                called: (passed.filter(rec => rec._id === name)[0] || { count: 0 }).count + (failed.filter(rec => rec._id === name)[0] || { count: 0 }).count,
                pending: (applied.filter(rec => rec._id === name)[0] || { count: 0 }).count + "/" + (pending.filter(rec => rec._id === name)[0] || { count: 0 }).count,
                currentCandidate: (currentCandidate.filter(rec => rec.createdbyname === name)[0] || { _id: "" }).name,
                userStatus: (userStatus.filter(rec => rec.name === name)[0] || { name: "" }).message,
                longCalls: (longCalls || [].filter(rec => rec.name === name)[0] || { name: "" }).count,
                idleAlert: (newLogTimeValue > calTimeValue),
                longCallsAlert: (newCalVol < longCallVol),
                loggedTime: ("00" + (rhours ? rhours : 0)).slice(-2) + ":" + ("00" + (rminutes ? rminutes : 0)).slice(-2) + ":00",
                calledTime: ("00" + (cRhours ? cRhours : 0)).slice(-2) + ":" + ("00" + (cRminutes ? cRminutes : 0)).slice(-2) + ":00",
                hrIdleTime: ("00" + (iTime > 60 ? parseInt(iTime / 60) : 0)).slice(-2) + ":" + ("00" + (iTime >= 1 ? parseInt(iTime - (iTime > 60 ? parseInt(iTime / 60) : 0) * 60) : 0)).slice(-2) + ":00",
                loginId: loginid,
                agentId: agentId,
                isCallingActive: Boolean((userStatus.filter(rec => rec.name === name)[0] || { name: "" }).isCallingActive),
                interviewid: (currentCandidate.filter(rec => rec.createdbyname === name)[0] || { _id: "" })._id,
                idleTime: idleTime,
                openTime: openTime,
              }
            })
            setRowData(newData)
            setLoadTime(new Date())
          } else props.showAlert(repos.message || repos, "success");
        })
        .catch((err) => props.showAlert(('' + err), "error"));
    }
    isLoading.current = false;
  }

  const Refresh = async () => {
    setFromDate(new Date().toISOString().substring(0, 10))
    setToDate(new Date().toISOString().substring(0, 10))
    LoadCurrentData()
  }

  const stopCalling = (activeUser) => {
    if (activeUser) {
      setOpenStopModel(false)
      isCallingActive.current = false;
      let apiURL = process.env.REACT_APP_API_URL + "/usercallingstatus/userstoptime/" + userStatusId;
      let apiParams = {
        method: "POST",
        headers: {
          iscallingactive: false,
          userid: activeUser._id,
          username: activeUser.name,
          stopcomments: encodeURIComponent(stopComments),
          authtoken: localStorage.getItem("loggedintoken")
        },
      };
      apiFetch(apiURL, apiParams)
        .then((res) => (res.status === 200 ? res.json() : res.text()))
        .then((repos) => {
          if (repos.data) {
          } else { props.showAlert("" + (repos.message || repos), "success"); }
        })
        .catch((err) => { props.showAlert(('' + err), "error"); });
    }
  }

  const startCalling = () => {
    let apiURL = process.env.REACT_APP_API_URL + "/usercallingstatus/userstarttime";
    let apiParams = {
      method: "POST",
      headers: {
        iscallingactive: true,
        userid: user._id,
        username: user.name,
        authtoken: localStorage.getItem("loggedintoken")
      },
    };
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          setUserStatusId(repos.data._id || repos.data.status_id)
          isCallingActive.current = true;
        } else { props.showAlert("" + (repos.message || repos), "success"); }
      })
      .catch((err) => { props.showAlert(('' + err), "error"); });
  }

  const UpdateCallingStatus = () => {
    if (isLoading.current === true) { return; }
    isLoading.current = true;
    if (isCallingActive.current !== true) {
      startCalling()
    } else {
      stopCalling(user)
    }
    isLoading.current = false;
  }

  const setCloseStopModel = () => { setOpenStopModel(false); }
  const closeStopModel = () => setOpenStopModel(false);
  const OpenStopModal = () => { setOpenStopModel(true); }
  const handleCloseLoginHours = () => setLoginHours(false)

  const selectFile = (e) => {
    var file = e.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = function (e) {
      var rawLog = reader.result.split(",")[1];
      var dataSend = {
        dataReq: { data: rawLog, name: file.name, type: file.type },
        fname: "uploadFilesToGoogleDrive",
      };
      apiFetch(
        process.env.REACT_APP_GOOGLEDRIVE_URL,
        { method: "POST", body: JSON.stringify(dataSend) }
      )
        .then((res) => res.json())
        .then((data) => {
          props.showAlert("Resume Uploaded Successfully", "success");
        })
        .catch((e) => props.showAlert((e), "error"));
    };
  };

  const sendWhatsappToCandidate = () => { }

  const handleClose = () => { setOpen(false); }

  const checkIdle = () => {
    if ((isCallingActive.current === true) && ((new Date() - alertStart.current) > 300000)) {
      setOpen(true);
      setTimeout(() => checkIdle(), 30000)
    }
  }

  const addApplicants = () => { setOpenApplicant(true) }

  const SearchCandidate = async () => {
    let apiURL = "";
    apiURL = process.env.REACT_APP_API_URL + "/interview/getinterviewbysearch/" + searchData;
    let apiParams = {
      method: "GET",
      headers: {
        searchBy: data,
        authtoken: localStorage.getItem("loggedintoken")
      }
    };
    await apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          if (repos.data.length == 1) {
            const rowData = ([repos.data[0]])?.map((interview) => {
              let IntvwTime = interview.interviewtime ? ((interview.interviewtime).length < 6 ? (interview.interviewtime) : new Date((interview.interviewtime)).toTimeString().slice(0, 5)) : new Date(new Date()).toTimeString().slice(0, 5);

              return {
                id: interview?._id,
                applicantid: interview?.applicantId,
                jobid: interview?.jobId._id,
                name: interview?.name,
                mobile: interview?.mobile,
                jobtitle: interview?.jobId.jobtitle,
                companyname: interview?.jobId.companyname,
                interviewername: interview?.interviewername,
                timespent: interview?.timeSpent,
                hrname: (interview.hrname && interview.hrname !== "undefined") ? interview.hrname : "",
                interviewdate: interview?.interviewdate && (new Date(interview?.interviewdate)),
                interviewtime: IntvwTime,
                interviewlocation: interview?.location,
                rounds: interview?.rounds,
                reference: interview?.reference,
                status: interview?.status.replace("Nextround", "Passed").replace("Next Round", "Passed"),
                feedback: interview?.feedback,
                bookmark: (interview.bookmark && interview.bookmark !== "undefined") ? interview.bookmark : false,
                bookmarkcomment: (interview.bookmarkcomments && interview.bookmarkcomments !== "undefined") ? interview.bookmarkcomments : "",
                languages: interview?.languages,
                englishrating: interview?.englishRating,
                communicationrating: interview?.communicationRating,
                hasAudio: interview?.hasAudio,
                createdbyname: interview?.createdbyname,
                createdbyid: interview?.createdbyId,
              };
            });
            setSelectedRow(rowData[0])
            setOpenScedule(true)
          } else {
            window.isIntentionalRedirect = true;
            window.location.href = "/interviewdetails?selectedCell=" + ([data, user._id, searchData]);
          }
        } else props.showAlert("" + (repos.message || repos), "success");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  const showCandidate = async (candidate, hr) => {
    var filters = localStorage.getItem("filters")
    let apiURL = "";
    if (candidate === "new" && user.accesstype == 5) {
      apiURL = process.env.REACT_APP_API_URL + "/interview/newverification/" + hr
    }
    else if (filterCallsByEducation === true && candidate === "new" && user.accesstype != 5) {
      apiURL = process.env.REACT_APP_API_URL + "/interview/newinterviewfilter/" + hr + "/" + callFilterText;
    }
    else if (candidate === "new" && user.accesstype != 5) {
      apiURL = process.env.REACT_APP_API_URL + "/interview/newinterviewfilter/" + hr
    }
    else {
      apiURL = process.env.REACT_APP_API_URL + "/interview/getinterview/" + candidate;
    }
    let apiParams = {
      method: "GET",
      headers: {
        filters: filters,
        authtoken: localStorage.getItem("loggedintoken")
      }
    };
    await apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          const rowData = ([repos.data])?.map((interview) => {
            let IntvwTime = interview.interviewtime ? ((interview.interviewtime).length < 6 ? (interview.interviewtime) : new Date((interview.interviewtime)).toTimeString().slice(0, 5)) : new Date(new Date()).toTimeString().slice(0, 5);
            return {
              id: interview?._id,
              applicantid: interview?.applicantId,
              jobid: interview?.jobId,
              name: interview?.name,
              mobile: interview?.mobile,
              jobtitle: interview?.jobtitle,
              companyname: interview?.companyname,
              interviewername: interview?.interviewername,
              timespent: interview?.timeSpent,
              hrname: (interview.hrname && interview.hrname !== "undefined") ? interview.hrname : "",
              interviewdate: interview?.interviewdate && (new Date(interview?.interviewdate)),
              interviewtime: IntvwTime,
              interviewlocation: interview?.location,
              rounds: interview?.rounds,
              reference: interview?.reference,
              status: interview?.status.replace("Nextround", "Passed").replace("Next Round", "Passed"),
              feedback: interview?.feedback,
              bookmark: (interview.bookmark && interview.bookmark !== "undefined") ? interview.bookmark : false,
              bookmarkcomment: (interview.bookmarkcomments && interview.bookmarkcomments !== "undefined") ? interview.bookmarkcomments : "",
              languages: interview?.languages,
              englishrating: interview?.englishRating,
              communicationrating: interview?.communicationRating,
              hasAudio: interview?.hasAudio,
              createdbyname: interview?.createdbyname,
              createdbyid: interview?.createdbyId,
            };
          });
          setSelectedRow(rowData[0])
          setOpenScedule(true)
        } else props.showAlert("No data available for selected filters!", "success");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  const msgCandidate = (candidate, hr) => {
    var filters = localStorage.getItem("filters")
    let apiURL = "";
    if (candidate === "new" && user.accesstype == 5) {
      apiURL = process.env.REACT_APP_API_URL + "/interview/newverification/" + hr
    }
    else if (filterCallsByEducation === true && candidate === "new" && user.accesstype != 5) {
      apiURL = process.env.REACT_APP_API_URL + "/interview/newinterviewfilter/" + hr + "/" + callFilterText;
    }
    else if (candidate === "new" && user.accesstype != 5) {
      apiURL = process.env.REACT_APP_API_URL + "/interview/newinterviewfilter/" + hr
    }
    else {
      apiURL = process.env.REACT_APP_API_URL + "/interview/getinterview/" + candidate;
    }
    let apiParams = {
      method: "GET",
      headers: {
        filters: filters,
        authtoken: localStorage.getItem("loggedintoken")
      }
    };
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          const rowData = ([repos.data])?.map((interview) => {
            let IntvwTime = interview.interviewtime ? ((interview.interviewtime).length < 6 ? (interview.interviewtime) : new Date((interview.interviewtime)).toTimeString().slice(0, 5)) : new Date(new Date()).toTimeString().slice(0, 5);
            return {
              id: interview?._id,
              applicantid: interview?.applicantId,
              jobid: interview?.jobId,
              name: interview?.name,
              mobile: interview?.mobile,
              jobtitle: interview?.jobtitle,
              companyname: interview?.companyname,
              interviewername: interview?.interviewername,
              timespent: interview?.timeSpent,
              hrname: (interview.hrname && interview.hrname !== "undefined") ? interview.hrname : "",
              interviewdate: interview?.interviewdate && (new Date(interview?.interviewdate)),
              interviewtime: IntvwTime,
              interviewlocation: interview?.location,
              rounds: interview?.rounds,
              reference: interview?.reference,
              status: interview?.status.replace("Nextround", "Passed").replace("Next Round", "Passed"),
              feedback: interview?.feedback,
              bookmark: (interview.bookmark && interview.bookmark !== "undefined") ? interview.bookmark : false,
              bookmarkcomment: (interview.bookmarkcomments && interview.bookmarkcomments !== "undefined") ? interview.bookmarkcomments : "",
              languages: interview?.languages,
              englishrating: interview?.englishRating,
              communicationrating: interview?.communicationRating,
              hasAudio: interview?.hasAudio,
              createdbyname: interview?.createdbyname,
              createdbyid: interview?.createdbyId,
            };
          });
          let apiURL = "https://" + (user.device === "mobile" ? "api" : "web") + ".whatsapp.com/send/?phone=+91" + rowData[0].mobile.trim().replace(' ', '').substring(rowData[0].mobile.trim().replace(' ', '').length - 10) + "&type=phone_number&app_absent=0&text=Good Day " + rowData[0].name + ",%0a%0aI am contacting you for a job vacancy (Work from Office). Please let me know the best time to call you.%0a%0aMy name is " + user.name + ", I am from Bizi Bees Outsourcing Private Limited. You can call me on " + user.phone + " as well at your convenient time to discuss about the vacancy.%0a%0aPlease follow us on our LinkedIn page url below for latest updates.%0a%0ahttps://www.linkedin.com/company/bizi-bees-outsourcing";
          window.open(apiURL, '_blank')
          UpdateMessagedStatus(rowData[0].id)
        } else props.showAlert("No data available for selected filters!", "success");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  const getAllChats = () => {
    let apiURL = process.env.REACT_APP_API_URL + "/getchats";
    let apiParams = { method: "GET" };
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          setMessageList((list) => [...list, repos.data])
        } else props.showAlert("" + (repos.message || repos), "success");
      })
      .catch((err) => props.showAlert(('' + err), "error"));
  }

  const cols1 = [
    { field: 'id', headerName: 'id', hide: true },
    { field: 'name', headerName: 'Name', hide: true },
    {
      width: 790, renderCell: (params) => {
        return [
          <div style={{ width: "100%", textAlign: "center" }}>
            <div style={{ borderColor: "blue", width: "100%", fontSize: "22px" }}>{params.row.stoptime ? "Called for " : "Calling Since "} <font style={{ backgroundColor: "yellow", color: "red", width: "100%", fontSize: "22px", fontWeight: "bold" }}>{parseInt(((params.row.stoptime ? new Date(params.row.stoptime) : new Date()) - new Date(params.row.starttime)) / 3600000)} Hr {parseInt(((params.row.stoptime ? new Date(params.row.stoptime) : new Date()) - new Date(params.row.starttime)) / 60000) - parseInt(((params.row.stoptime ? new Date(params.row.stoptime) : new Date()) - new Date(params.row.starttime)) / 3600000) * 60} Mn</font> from {params.row.starttime ? (new Date(params.row.starttime).toLocaleTimeString()) : ""}{params.row.stoptime ? " to " : ""}{params.row.stoptime ? (new Date(params.row.stoptime).toLocaleTimeString()) : ""}</div>
            <div style={{ backgroundColor: "red", color: "white", width: "100%", fontSize: "22px" }}>{params.row.comments}</div></div>
        ];
      },
    },
  ];

  const rowData1 = (loginDetails)?.map((emp) => {
    return {
      id: emp?._id,
      name: emp?.userName,
      starttime: emp?.startTime,
      stoptime: emp?.stopTime,
      comments: emp?.stopComments,
    };
  });

  // =========================================================
  // ✅ 4. COLUMNS AND EFFECTS (OPTIMIZED)
  // =========================================================

  // 1. INITIAL LOAD: Fetch baseline data exactly ONCE on mount
  useEffect(() => {
    getUsers();
    interviewStatus();
    LoadCurrentData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 2. BACKGROUND POLLING: Only fires on the interval
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!openShedule) {
        LoadCurrentData();
      }
    }, 15000);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openShedule, fromDate, toDate]);

  // 3. BACKEND SYNC & MICROPHONE: Safely sync user status
  useEffect(() => {
    const activeRes = result.find((res) => res.user_id === user._id || res.name === user.name);

    if (activeRes) {
      const isActive = activeRes.isCallingActive === true || activeRes.isCallingActive === "true" || activeRes.isCallingActive === 1 || activeRes.isCallingActive === "1";
      isCallingActive.current = isActive;
      setUserStatusId(activeRes.status_id || activeRes._id);

      // Trigger microphone ONLY if the backend says they are actively calling
      if (isActive) {
        navigator.mediaDevices.getUserMedia({ audio: true })
          .then(() => {
            alertStart.current = new Date();
            setTimeout(() => checkIdle(), 300000);
          })
          .catch(err => {
            alert("Your microphone is not accessible!");
            setStopComments("Stopped since microphone is not accessible!");
            stopCalling(user);
            props.showAlert("Calling is Stopped!!", "success");
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result, user]);

  // 4. CLEANUP: Reset stop comments when modal closes
  useEffect(() => {
    if (!openStopModel) {
      setStopComments("");
    }
  }, [openStopModel]);

  // 5. GRID REFRESH: Force Grid update when active users change
  useEffect(() => {
    setGridVersion(v => v + 1);
  }, [activeUsers, users]);

  const cols = useMemo(() => [
    {
      field: 'name', headerName: 'Name', width: 180, headerClassName: 'super-app-theme--header', renderCell: (params) => {

        const isAllowed = (Number(user?.accesstype) === 5) || (Number(user?.accesstype) === 1);

        const cleanName = (n) => n ? n.toString().toLowerCase().trim() : "";
        const currentRowName = cleanName(params.row.name);

        const targetUserId = params.row.agentId ||
          (users.find(rec => cleanName(rec.name) === currentRowName) || {})._id ||
          "";

        const isOnline = activeUsers.some(usr => String(usr.userId).trim() === String(targetUserId).trim());
        const isListening = staffId === targetUserId;

        return [<>
          {params.row.name ? params.row.name : ""}
          {isOnline ? <span style={{ fontSize: '10px', color: 'green', fontWeight: 'bold', marginLeft: '5px' }}>(ON)</span> : null}

          {isAllowed && isOnline &&
            <Button
              size="small"
              className="btn"
              style={{
                border: isListening ? "2px solid green" : "",
                borderRadius: isListening ? "25px" : ""
              }}
              title="Speaker"
              onClick={() => {
                if (!targetUserId) {
                  props.showAlert("User not online or ID missing", "error");
                  return;
                }
                if (isListening) {
                  stopCall();
                  setStaffId(null);
                }
                else {
                  callUser(targetUserId);
                  setStaffId(targetUserId);
                }
              }}
            >
              {isListening ? <VolumeUpIcon /> : <VolumeOffIcon />}
            </Button>}
        </>];
      },
    },
    {
      field: 'currentCandidate', headerName: 'Candidate/Activity', width: 190, headerClassName: 'super-app-theme--header', renderCell: (params) => {
        return [<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: params.row.isCallingActive === false ? "red" : "white", color: params.row.isCallingActive !== true ? "white" : params.row.currentCandidate ? "black" : "red", width: "100%", height: "100%" }}>
          <div style={{ flexGrow: 1, overflow: 'hidden' }}>
            {params.row.isCallingActive === false ? <marquee>{params.row.userStatus}</marquee> :
              user.name === params.row.name || user.accesstype == 5 ?
                user.name === params.row.name && user.accesstype == 5 ?
                  <button style={{ border: "1px solid", padding: "2px 6px" }} onClick={() => { showCandidate("new", params.row.name) }} >{"Verify Candidate"}</button> :
                  !params.row.currentCandidate && user.accesstype == 5 ? "Idle" :
                    <button style={{ border: "1px solid", padding: "2px 6px" }} onClick={() => {
                      alertStart.current = new Date(); setTimeout(() => checkIdle(), 300000);
                      showCandidate(params.row.currentCandidate ? params.row.interviewid : "new", params.row.name)
                    }} >{params.row.currentCandidate ? params.row.currentCandidate : "Call Candidate"}</button> :
                params.row.currentCandidate ? params.row.currentCandidate : ""
            }
          </div>
          <Button
            size="small"
            style={{ minWidth: '30px', padding: '2px', marginLeft: '4px', color: params.row.isCallingActive === false ? 'white' : 'blue' }}
            title="Time Utilization Report"
            onClick={(e) => {
              e.stopPropagation(); // Prevents triggering the row's onCellClick
              setReportUserId(params.row.loginId || params.row.agentId);
              setReportUserName(params.row.name);
              setReportOpen(true);
            }}
          >
            <AssessmentIcon fontSize="small" />
          </Button>
        </div>];
      },
    }, ,
    {
      field: 'openTime', headerName: 'Call/Idle/Stopped', width: 120, headerClassName: 'super-app-theme--header', renderCell: (params) => {
        return [
          <div style={{ backgroundColor: (params.row.isCallingActive === true && params.row.openTime > 300) ? "red" : "white", color: (params.row.isCallingActive === true && params.row.openTime > 300) ? "white" : (params.row.isCallingActive === true && params.row.openTime > 210) ? "red" : "green", }}>
            {String(parseInt(params.row.openTime / 60 / 60)).padStart(2, '0')}:{String(parseInt((params.row.openTime / 60) % 60)).padStart(2, '0')}:{String(params.row.openTime % 60).padStart(2, '0')}
          </div>
        ];
      },
    },
    { field: 'verified', headerName: 'Verified - ' + (showOnlyHR ? rowData.filter(x => users.filter(u => u.name === x.name)[0]) : rowData).reduce((prv, curr) => prv + curr.verified, 0), width: 90, headerClassName: 'super-app-theme--header', },
    { field: 'verificationFailed', headerName: 'Ver Failed - ' + (showOnlyHR ? rowData.filter(x => users.filter(u => u.name === x.name)[0]) : rowData).reduce((prv, curr) => prv + curr.verificationFailed, 0), width: 100, headerClassName: 'super-app-theme--header', },
    { field: 'verificationPending', headerName: 'Ver Pending - ' + (showOnlyHR ? rowData.filter(x => users.filter(u => u.name === x.name)[0]) : rowData).reduce((prv, curr) => prv + parseInt(curr.verificationPending.split('/')[0]), 0) + "/" + (showOnlyHR ? rowData.filter(x => users.filter(u => u.name === x.name)[0]) : rowData).reduce((prv, curr) => prv + parseInt(curr.verificationPending.split('/')[1]), 0), width: 130, headerClassName: 'super-app-theme--header', },
    { field: 'passed', headerName: 'Passed - ' + (showOnlyHR ? rowData.filter(x => users.filter(u => u.name === x.name)[0]) : rowData).reduce((prv, curr) => prv + curr.passed, 0), width: 90, headerClassName: 'super-app-theme--header', },
    { field: 'failed', headerName: 'Failed - ' + (showOnlyHR ? rowData.filter(x => users.filter(u => u.name === x.name)[0]) : rowData).reduce((prv, curr) => prv + curr.failed, 0), width: 90, headerClassName: 'super-app-theme--header', },
    { field: 'scheduled', headerName: 'Scheduled - ' + (showOnlyHR ? rowData.filter(x => users.filter(u => u.name === x.name)[0]) : rowData).reduce((prv, curr) => prv + curr.scheduled, 0), width: 120, headerClassName: 'super-app-theme--header', },
    { field: 'called', headerName: 'Interviews - ' + (showOnlyHR ? rowData.filter(x => users.filter(u => u.name === x.name)[0]) : rowData).reduce((prv, curr) => prv + curr.called, 0), width: 120, headerClassName: 'super-app-theme--header', },
    { field: 'notReachable', headerName: 'Not Reached - ' + (showOnlyHR ? rowData.filter(x => users.filter(u => u.name === x.name)[0]) : rowData).reduce((prv, curr) => prv + curr.notReachable, 0), width: 125, headerClassName: 'super-app-theme--header', },
    { field: 'messaged', headerName: 'Messaged - ' + (showOnlyHR ? rowData.filter(x => users.filter(u => u.name === x.name)[0]) : rowData).reduce((prv, curr) => prv + curr.messaged, 0), width: 120, headerClassName: 'super-app-theme--header', },
    {
      field: 'loggedTime', headerName: 'Logged Time', width: 95, headerClassName: 'super-app-theme--header', renderCell: (params) => {
        return [<>{params.row.loggedTime ? params.row.loggedTime : 0}</>];
      },
    },
    {
      field: 'calledTime', headerName: 'Calls Time', width: 80, headerClassName: 'super-app-theme--header', renderCell: (params) => {
        return [<>{params.row.calledTime ? params.row.calledTime : 0}</>];
      },
    },
    {
      field: 'hrIdleTime', headerName: 'Idle Time', width: 80, headerClassName: 'super-app-theme--header', renderCell: (params) => {
        return [<div style={{ width: "100%", backgroundColor: params.row.idleAlert ? "red" : "white", color: params.row.idleAlert ? "white" : "black", fontWeight: params.row.idleAlert ? "bold" : "normal" }}>
          {params.row.hrIdleTime ? params.row.hrIdleTime : 0}
        </div>];
      },
    },
    {
      field: 'longCalls', headerName: 'Long Calls', width: 80, headerClassName: 'super-app-theme--header', renderCell: (params) => {
        return [<div style={{ width: "100%", backgroundColor: params.row.longCallsAlert ? "red" : "white", color: params.row.longCallsAlert ? "white" : "black", fontWeight: params.row.longCallsAlert ? "bold" : "normal" }}>
          {params.row.longCalls ? params.row.longCalls : 0}
        </div>];
      },
    },
    { field: 'pending', headerName: 'Available - ' + (showOnlyHR ? rowData.filter(x => users.filter(u => u.name === x.name)[0]) : rowData).reduce((prv, curr) => prv + parseInt(curr.pending.split('/')[0]), 0) + '/' + (showOnlyHR ? rowData.filter(x => users.filter(u => u.name === x.name)[0]) : rowData).reduce((prv, curr) => prv + parseInt(curr.pending.split('/')[1]), 0), width: 160, headerClassName: 'super-app-theme--header', },
    { field: 'id', headerName: 'id', hide: true },
  ], [activeUsers, users, user, callUser, stopCall, staffId, rowData, showOnlyHR]);

  return (
    <div className={!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) ? 'dashboard_pc_module' : 'dashboard_mob_module'}>

      {(!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) && user.accesstype > 1) ?
        <div style={{ textAlign: "center" }} >
          {user.accesstype > 1 ?
            <>Loaded Time: {loadTime.toLocaleTimeString()} <OnlinePredictionSharpIcon style={{ color: "red" }} /><Button size='small' variant="contained" style={{ color: "white", backgroundColor: "red" }} title="Live" onClick={() => Refresh()}>Live</Button>
            </> : ""}
          {user.accesstype > 1 ? <> &nbsp;<input type="checkbox" checked={showOnlyHR} onChange={() => setShowOnlyHR(!showOnlyHR)} />&nbsp;Show only HR</> : ""}
        </div> : ""}

      {(!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) && user.accesstype > 1) ?
        <div style={{ textAlign: "center" }}>
          <div>
            <Button size='small' variant="contained" title="Add Applicant" style={{ textAlign: "center" }} onClick={() => addApplicants()}><PersonAddIcon /></Button>   &nbsp;
            {!isLoading.current ? <Button size='small' variant="contained" title={(isCallingActive.current === true ? "Stop " : "Start ") + "Calling"} style={{ textAlign: "center" }} onClick={() => {
              isCallingActive.current !== true ? UpdateCallingStatus() : OpenStopModal()
            }}>
              {(isCallingActive.current === true ? <StopCircleIcon variant="contained" /> : <PlayCircleIcon />)}</Button> : ""}&nbsp;
            <select name="Search" id="search" className="dropdown" value={data} onChange={(e) => setData(e.target.value)}>
              <option value="history">History</option>
              <option value="mobile">Mobile</option>
              <option value="name">Name</option>
              <option value="feedback">Feedback</option>
              <option value="language">Language</option>
              <option value="area">Location</option>
              <option value="education">Education</option>
            </select> &nbsp;
            {data !== 'history' ?
              <input type="search" placeholder='Search' id="gsearch" className="inputfield" name="gsearch" value={searchData} onChange={(e) => setSearchData(e.target.value)} />
              : <><input type="date" className="inputfield" value={fromDate}
                onChange={(value) => {
                  setFromDate(value.target.value);
                }} />&nbsp;
                <input type="date" className="inputfield" value={toDate}
                  onChange={(value) => {
                    setToDate(value.target.value);
                  }} /></>}
            &nbsp;
            <Button size='small' variant="contained" title="search" onClick={() => data !== 'history' ? SearchCandidate() : LoadPreviousData()}><SearchIcon /></Button>
          </div>
        </div> : ""}

      {(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) && user.accesstype > 1 ? showHRDasboard === "Employee" ? <EmployeeDashboardMob showAlert={props.showAlert} rowData={rowData} showHr={(e) => setShowHRDasboard(e)} /> : <AdminDashboardMob showAlert={props.showAlert} showHr={(e) => setShowHRDasboard(e)} /> :
        <Box
          sx={{
            height: 300,
            '& .super-app-theme--header': {
              backgroundColor: 'cornflowerblue',
              color: "white",
            },
          }}
        >
          <div style={{ display: "block", textAlign: "center" }}>
            <div style={{ width: '80%', textAlign: "-webkit-center", verticalAlign: "top", display: "inline-block" }}>
              {user.accesstype > 1 ?
                <DataGrid
                  key={gridVersion}
                  style={{ height: 750 }}
                  initialState={{
                    sorting: {
                      sortModel: [{ field: 'name', sort: 'asc' }],
                    },
                  }}
                  rows={showOnlyHR ? rowData.filter(x => users.filter(user => user.name === x.name)[0]) : rowData}
                  columns={cols}
                  onCellClick={(cell) =>
                    (cell.field != "currentCandidate" && cell.field != "openTime" && cell.field != "pending" && cell.field != "loggedTime" && cell.field != "calledTime" && cell.field != "hrIdleTime" && cell.field != "longCalls" && cell.field != "name" && cell.row.name == user.name) || (user.accesstype == 5 && cell.field != "currentCandidate" && cell.field != "openTime" && cell.field != "loggedTime" && cell.field != "calledTime" && cell.field != "hrIdleTime" && cell.field != "longCalls" && cell.field != "name") ?
                      viewData(([cell.field, user._id, cell.row.name, fromDate, toDate])) : cell.field == "loggedTime" ? OpenLoginhoursGrid(cell.row.loginId, cell.row.name, cell.row.loggedTime) : null
                  }
                />
                :
                <>
                  {(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) ?
                    <EmployeeDashboardMob showAlert={props.showAlert} rowData={rowData} /> :
                    <EmployeeDashboardMob showAlert={props.showAlert} rowData={rowData} />
                  }
                </>
              }
            </div>
            {user.accesstype == 5 ? !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) ? <div style={{ width: "360px", display: "inline-block", verticalAlign: "top", textAlign: "center" }}>
              <div className='chat-window'>
                <div id="chatBody" style={{ height: 500, width: "360px", border: "2px solid black", overflowY: "scroll" }} className='chat-body'>
                  {messageList.map((content) => {
                    return (
                      <div className='message' id={user.name === content.userName ? 'you' : 'other'}>
                        <div className='message-body'>
                          <div className='message-content' style={{ border: (((new Date() - new Date(new Date(new Date().setHours(parseInt(content.time.split(':')[0]))).setMinutes(parseInt(content.time.split(':')[1])))) / 60000 < 2) ? "2px solid red" : "0px") }}>
                            <p id={user.name === content.userName ? 'you' : 'other'}>{content.message.substring(0, 5) === "href:" ? <a href={content.message.split('@&@')[1]} target="_blank" style={{ color: "white", fontWeight: "bold" }}>{content.message.split('@&@')[0].split(':')[1]}</a> : content.message}</p>
                          </div>
                          <div className='message-meta'>
                            <p id={user.name === content.userName ? 'you' : 'other'}>{content.time}</p>
                            <p id='author' style={{ backgroundColor: (content.message === longCallMsg || content.message === longTimeIdleMsg ? "red" : "white"), color: (content.message === longCallMsg || content.message === longTimeIdleMsg ? "white" : "black") }}>{content.userName}</p>
                          </div>
                        </div>
                      </div>
                    );

                  })
                  }
                </div>
              </div>
              <div >
                <AttachFileIcon
                  style={{ marginLeft: "2px", marginRight: "3px", color: "cornflowerblue" }}
                  onClick={(e) =>
                    document
                      .getElementById("candidateResume" + user._id)
                      .click()
                  }
                />
                <input
                  id={"candidateResume" + user._id}
                  type="file"
                  placeholder="Upload Resume"
                  style={{ display: "none" }}
                  name="Resume"
                  onChange={(e) => {
                    selectFile(e)
                  }}
                ></input>
              </div>
            </div> : "" : ""}
          </div>
        </Box>}

      {staffId && (
        <MonitorStaff
          user={user}
          selectedStaff={liveUsers.find(u => u.userId === staffId)}
          callUser={callUser}
          stopCall={() => { stopCall(); setStaffId(null); }}
          remoteStream={remoteStream}
          callState={callState}
          activeUsers={liveUsers}
          networkStats={networkStats}
          sendToggleVideo={sendToggleVideo}
          startRecording={startRecording}
          stopRecording={stopRecording}
          recording={recording}
          networkQuality={networkQuality}
        />
      )}

      <Modal
        open={openStopModel}
        onClose={closeStopModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflow: 'scroll', textAlign: "center" }}
      >
        <Box sx={stopModalStyle}>
          <Typography id="modal-modal-description" component="div">
            <Container style={{ padding: "0px" }}>
              <div className="content6">
                <div style={{ alignItems: "center" }}>
                  <h2 className='fnt2' style={{ left: 0, top: 0 }}><b>Enter Stop Reason</b></h2>
                  <Button title="Close" variant="Standard" sx={{ float: "right", right: 0, top: 0, position: "absolute", height: 35, width: 5, color: "white", backgroundColor: "red" }} onClick={() => setCloseStopModel()} ><CloseIcon /></Button>
                </div>
                <br />
                <TextField id="stopReason" multiline rows={3} sx={{ m: 1, width: '35ch' }} size="small" label="Enter Stop Reason" variant="outlined" value={stopComments} onChange={(e) => {
                  setStopComments(e.target.value);
                }} />
                <br />
                <Button variant="contained" sx={{ m: 1, width: '35ch', backgroundColor: "#14c871" }} onClick={() => { ; stopComments.trim().length > 0 ? UpdateCallingStatus() : props.showAlert("Please Enter Stop Reason!!!", "error"); }}>Submit</Button>
              </div>
            </Container>
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={openLoginHours}
        onClose={handleCloseLoginHours}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={Login}>
          <div className="content2">
            <div style={{ alignItems: "center" }}>
              <h2 className='fnt2' style={{ left: 0, top: 0 }}><b>{empName} - {empCallingTime}</b></h2>
              <Button title="Close" variant="Standard" sx={{ float: "right", right: 0, top: 0, position: "absolute", height: 35, width: 5, color: "white", backgroundColor: "red" }} onClick={() => setLoginHours(false)} ><CloseIcon /></Button>
            </div>
            <Typography id="modal-modal-description" component="div" sx={{ mt: 1 }}>
              <div style={{ height: 1000, width: "100%" }}>
                <DataGrid rows={rowData1} columns={cols1} rowHeight={65} components={{
                  Header: () => null, Footer: () => null,
                }} />
              </div>
            </Typography>
          </div>
        </Box>
      </Modal>

      <ScheduleInterviewUI open={openShedule} showAlert={props.showAlert} interview={selectedRow} refresh={() => LoadCurrentData()} close={(openNext) => { LoadCurrentData(); setOpenScedule(false); alertStart.current = new Date(); setTimeout(checkIdle, 300000); if (openNext === true) showCandidate("new", user.name) }} />

      <ApplicantPopup open={openApplicant} showAlert={props.showAlert} close={() => { setOpenApplicant(false); }} />

      <TimeUtilizationReport
        open={reportOpen}
        onClose={() => setReportOpen(false)}
        userId={reportUserId}
        userName={reportUserName}
      />

    </div>
  )
}

export default Dashboard